import *
    as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useHistory, useLocation } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, FormGroup, Input, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import * as CustomerFeedbackMdls from '../../models/CustomerFeedbackModel';
import * as CustomerFeedbackStore from '../../store/CustomerFeedback';
import '../../../node_modules/cleave.js/dist/addons/cleave-phone.us'
const Cleave = require('../../../node_modules/cleave.js/react');


type MyProps =
    { SessionState: SessionMdl.SessionModel, FeedbackState: CustomerFeedbackMdls.CustomerFeedbackModel } & typeof CustomerFeedbackStore.actionCreators;

const CustomerFeedback: React.FunctionComponent<MyProps> = (props: MyProps) => {

    const historyHook = useHistory();

    useEffect(() => {
        if (props.FeedbackState.success == 'Y') {
            historyHook.replace('/Feedback');
            props.resetState();
        }
        if (props.FeedbackState.error) {
            alert(props.FeedbackState.error);
        }
    }, [props]);

    const [CustomerFeedbackLocal, updateCustomerRequestInfo] = useState<CustomerFeedbackMdls.CustomerFeedbackModel>({ ...CustomerFeedbackMdls.initialState });

    const SubmitEvent = (e: React.FormEvent) => {
        console.log(CustomerFeedbackLocal);
        e.preventDefault();
        props.request(CustomerFeedbackLocal);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.value };
        updateCustomerRequestInfo({ ...CustomerFeedbackLocal, ...valueChanged });
    }

    const handleCleveChange = (e: any) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.rawValue };
        updateCustomerRequestInfo({ ...CustomerFeedbackLocal, ...valueChanged });

    }
    const RequestBtn = () => {
        if (!props.FeedbackState.processing) {
            return (<input type="submit" value="Submit" className="btn btn-success" id="RequestBtn" name="RequestBtn" />);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.FeedbackState.processing} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            {
                <Card>
                    <CardBody>
                        <form onSubmit={SubmitEvent}>
                            <Row>
                                <Col xs={12}>
                                    <br />
                                    <RequestBtn />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Name"} />
                                    <input type="text" required onChange={handleChange} className="form-control" key="contactPerson" id="contactPerson" name="contactPerson" value={CustomerFeedbackLocal.contactPerson} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Contact Phone #"} />
                                    {/* <input type="text" onChange={handleChange} className="form-control" key="contactPersonPhone" id="contactPersonPhone" name="contactPersonPhone" value={CustomerFeedbackLocal.contactPersonPhone} />*/}
                                    <Cleave
                                        required
                                        options={{
                                            uppercase: true,
                                            //delimiters: [' ', ' '],
                                            blocks: [3, 3, 4],
                                            numericOnly: true
                                        }} className="form-control"
                                        onChange={handleCleveChange}
                                        key="contactPersonPhone" id="contactPersonPhone" name="contactPersonPhone"
                                        value={CustomerFeedbackLocal.contactPersonPhone}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Invoice"} />
                                    <input type="text" onChange={handleChange} className="form-control" key="invoiceNum" id="invoiceNum" name="invoiceNum" value={CustomerFeedbackLocal.invoiceNum} />
                                </Col>
                            </Row>
                            <FormGroup>
                                <SaLabel Text={"Comments"} />
                                <Input required type="textarea" id="customerComments" name="customerComments" value={CustomerFeedbackLocal.customerComments} onChange={handleChange}>
                                </Input>
                            </FormGroup>
                            <Row>
                                <Col xs={12}>
                                    <br />
                                    <RequestBtn />
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            }
        </Container>
    );
}

export default connect((state: ApplicationState) =>
({
    ...{
        FeedbackState: state.customerFeedbackState,
        SessionState: state.sessionState
    }
}),
    CustomerFeedbackStore.actionCreators)(CustomerFeedback as any);